module.exports = __webpack_public_path__ + "static/media/screen_gallery_plus_9.4524f930.svg";